import { useContext } from 'react';
import { FormContext } from '../formContext';

export function useFormContext() {
  return useContext(FormContext);
}
